const baseUrl = (process.env.REACT_APP_UPLOAD_API_URL || '').replace(/\/$/, '');

export function isUploadServerConfigured(): boolean {
  return Boolean(baseUrl);
}

export function getUploadApiBaseUrl(): string {
  return baseUrl;
}

export type UploadResult = {
  ok: boolean;
  filename: string;
  size: number;
  mimetype: string;
};

export async function uploadPhoto(blob: Blob, filename = 'capture.jpg'): Promise<UploadResult> {
  if (!baseUrl) {
    throw new Error('URL du serveur d’upload non configurée (REACT_APP_UPLOAD_API_URL)');
  }

  const formData = new FormData();
  formData.append('photo', blob, filename);

  const headers: HeadersInit = {};
  const token = process.env.REACT_APP_UPLOAD_TOKEN;
  if (token) {
    headers['X-Upload-Token'] = token;
  }

  const res = await fetch(`${baseUrl}/upload`, {
    method: 'POST',
    body: formData,
    headers,
  });

  const text = await res.text();
  let data: unknown;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }

  if (!res.ok) {
    const msg =
      data && typeof data === 'object' && data !== null && 'error' in data
        ? String((data as { error: string }).error)
        : text || res.statusText;
    throw new Error(msg || `Erreur ${res.status}`);
  }

  if (!data || typeof data !== 'object' || !('filename' in data)) {
    throw new Error('Réponse serveur inattendue');
  }

  return data as UploadResult;
}
